export default __webpack_public_path__ + "static/media/doc.4ee6ab56.png";